import { render, staticRenderFns } from "./tableBuilder.vue?vue&type=template&id=8d23b11e"
import script from "./tableBuilder.vue?vue&type=script&lang=js"
export * from "./tableBuilder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports